import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiClientService } from 'src/app/@core/services/api-client.service';
import { HomeImageType } from '../enums/home-image-type.enum';
import { ApplicationRoutes } from 'src/app/@core/routes/application-routes.const';

@Injectable({
  providedIn: 'root'
})
export class HomeService {
  constructor(private _ApiClientService:ApiClientService) { }

  getSliderData():Observable<any> {
    let type = HomeImageType.MainBanner;
    return this._ApiClientService.get(`${ApplicationRoutes.HomeImage.HomeImages}?type=${type}`);
  }

  getTrainingTracks():Observable<any> {
    return this._ApiClientService.get(`${ApplicationRoutes.LearningPath.LearningPaths}`);
  }

  getPartners():Observable<any> {
    return this._ApiClientService.get(`${ApplicationRoutes.Partner.Partners}`);
  }

  getAdvertisements() {
    return this._ApiClientService.get(`${ApplicationRoutes.HomeAdvertising.GetPublished}`);
  }
}
